module.exports = __webpack_public_path__ + "static/media/anvil-squad3.17627efb.jpg";